var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 0L7.32471 5.16876L3.70898 0.0839591C3.82268 0.0293318 3.94686 0 4.07464 0H11.0001Z",
    fill: "#B1E4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.291 0.0839591L14.6752 5.16876L10.9999 0H17.9253C18.0531 0 18.1773 0.0292848 18.291 0.0839591Z",
    fill: "#B1E4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9994 5.17074H14.6755L18.2913 0.0859375H18.2918C18.4191 0.147041 18.5328 0.239917 18.6238 0.359168L21.7888 4.49912C21.9375 4.69336 22.0076 4.93327 21.9994 5.17074Z",
    fill: "#75CEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 0L7.3241 5.16862H14.6751L10.9996 0Z",
    fill: "#90D8F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32448 5.17074H0.000645198C-0.00756171 4.93327 0.0625193 4.69336 0.211232 4.49912L3.37626 0.359168C3.46723 0.239964 3.58092 0.147041 3.70828 0.0859375H3.70875L7.32448 5.17074Z",
    fill: "#E4F6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6749 5.16797L11.1315 17.9887C11.0442 18.0026 10.955 18.0026 10.8677 17.9887L7.32422 5.16797H14.6749Z",
    fill: "#75CEF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8683 17.9887C10.6714 17.9574 10.4821 17.8556 10.3353 17.6832C10.3348 17.6827 10.3339 17.6817 10.3335 17.6812L0.242973 5.80928C0.241598 5.80778 0.240696 5.80627 0.239321 5.80482C0.0878581 5.62451 0.00780849 5.39746 0.000976562 5.16797H7.32481L10.8683 17.9887Z",
    fill: "#B1E4F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9989 5.16797C21.992 5.39746 21.912 5.62451 21.7605 5.80482C21.7592 5.80632 21.7583 5.80782 21.7569 5.80928L11.6664 17.6812C11.6659 17.6818 11.665 17.6828 11.6646 17.6832C11.5177 17.8556 11.3285 17.9574 11.1316 17.9887L14.675 5.16797H21.9989Z",
    fill: "#6BBEF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIconBlue);
export default __webpack_public_path__ + "static/media/diamond-icon-blue.f0661a1d8f6ff3ea2735b233459047af.svg";
export { ForwardRef as ReactComponent };